import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  RESTRICTED_KEYWORDS_LIST,
  DELETE_SINGLE_RESTRICTED_KEYWORD,
} from "../../../Constants/Config";

const initialState = {
  loading: false,
  list: [],
  error: "",
};

export const fetchRestrictedKeywordsList = createAsyncThunk(
  "restrictedKeywords/fetchList",
  async (data, { rejectWithValue }) => {
    const { token, ...rest } = data;
    try {
      const payload = { id: "", ...rest };
      const response = await axios.post(BASE_URL + RESTRICTED_KEYWORDS_LIST, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // New backend shape: { status: true/false, data: [...] }
      if (response.data.status && Array.isArray(response.data.data)) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const deleteRestrictedKeyword = createAsyncThunk(
  "restrictedKeywords/deleteSingle",
  async (data, { rejectWithValue }) => {
    const { token, id, ...rest } = data;
    try {
      await axios.post(
        BASE_URL + DELETE_SINGLE_RESTRICTED_KEYWORD,
        { ...rest, id },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { id };
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

const restrictedKeywordsSlice = createSlice({
  name: "restrictedKeywords",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchRestrictedKeywordsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRestrictedKeywordsList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
        state.error = "";
      })
      .addCase(fetchRestrictedKeywordsList.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.error?.message || "Failed to fetch";
      })
      .addCase(deleteRestrictedKeyword.fulfilled, (state, action) => {
        state.list = state.list.filter((item) => item.id !== action.payload.id);
      });
  },
});

export default restrictedKeywordsSlice.reducer;
